<template>
  <a-modal
    v-model="isVisible"
    :footer="null"
    title="Proceso de Captura de Firma"
    @cancel="$emit('cancel')"
    :width="500"
  >
    <div ref="wacom-signature-pad" style="height: 320px"></div>
  </a-modal>
</template>

<script>
import { defineComponent } from 'vue'

import { WacomSignaturePad } from '@lumile/lumbre-wacom-sginature-pad'

export default defineComponent({
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isVisible: false,

    blob: null
  }),

  methods: {
    onCancel () {
      this.isVisible = false
      this.$emit('cancel')
    },
    onConfirm (event) {
      this.$emit('confirm', event)
    },
    open (who, why, extraData = null) {
      this.isVisible = true

      this.$nextTick(() => {
        // Licencia de demo
        // const key = `eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJiMzNhYWUyODA0NmM0MmE5OTgyY2E1NTdkZjhmY2YxOCIsImV4cCI6MTY3ODk1OTEwNCwiaWF0IjoxNjcxMTgzMTMyLCJzZWF0cyI6MCwicmlnaHRzIjpbIkpTX0NPUkUiLCJTSUdfU0RLX0NPUkUiLCJTSUdfU0RLX0lTTyIsIlNJR19TREtfRU5DUlBZVElPTiJdLCJkZXZpY2VzIjpbIldBQ09NX0FOWSJdLCJ0eXBlIjoiZXZhbCIsImxpY19uYW1lIjpudWxsLCJ3YWNvbV9pZCI6ImIzM2FhZTI4MDQ2YzQyYTk5ODJjYTU1N2RmOGZjZjE4IiwibGljX3VpZCI6ImFmYzkyNGIyLTBiZTItNDAyZC1hYTA0LWRiZDY0MDdlYTc4MCIsImFwcHNfd2luZG93cyI6W10sImFwcHNfaW9zIjpbXSwiYXBwc19hbmRyb2lkIjpbXSwibWFjaGluZV9pZHMiOltdfQ.M2Cphus6EWDxKlwQspqtDjlAUPu_aXZ2SjyEPVqtw6iLlwCizyg9-2oPVGvEy5-h-Mr1oFzzOe4IvWhwYDaCRj1llvRaZmbWplXD0iyVrMp4RLhVV1MsLt4MUvWMj9yJDEs5Q1UP6bBr0A3PXwL2r1jho-jUiNWjqmPbWt_ER92MPzsKtxunfxEvvstDJKT8VXpVGdBmu2Qqv__QROPfJRo_DvR9tPP1HCk8HJJCvfqHcKuiFecoqhm1hZFiwSb0Upg5Ei4T1aT4kVH_py8sZ_54HQJjgLzNRvFmm0RHXbUVe-pcuChclJW0EH_fGKjQL3VCWjrU8YXX7howXTlYZA`

        const key = `eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI3YmM5Y2IxYWIxMGE0NmUxODI2N2E5MTJkYTA2ZTI3NiIsImV4cCI6MTY5NjcyMzE5OSwiaWF0IjoxNjg4NzI4OTU1LCJzZWF0cyI6MCwicmlnaHRzIjpbIlNJR19TREtfQ09SRSIsIkpTX0NPUkUiLCJTSUdfU0RLX0lTTyIsIlNJR19TREtfRU5DUllQVElPTiJdLCJkZXZpY2VzIjpbXSwidHlwZSI6InByb2QiLCJsaWNfbmFtZSI6IkphdmFzY3JpcHQgU2lnbmF0dXJlIFNESyAzLW1vbnRoIFByb2R1Y3Rpb24gbGljZW5zZSBmb3IgQWNjZWRyYSIsIndhY29tX2lkIjoiMTZkNWIwMzNmZWMxNDk4OGJmNzJkNjMzNjg1M2YxOGYiLCJsaWNfdWlkIjoiYTE3NTFlOGItMzU3Zi00YTVlLThlZjAtNWEyNmQzOWNhOWNhIiwiYXBwc193aW5kb3dzIjpbXSwiYXBwc19pb3MiOltdLCJhcHBzX2FuZHJvaWQiOltdLCJtYWNoaW5lX2lkcyI6W10sInd3dyI6W10sImJhY2tlbmRfaWRzIjpbXX0.KmwTHnyvTTxvrZ62huDHFAC-6brI_aEIL1Sn9VsCJG-i2XFXm4j36atnxtTajR7PgZ9OKT3cXLOvNwbbftp5WhahCzoW-iTAlXHj8-cV2KGIYbJHbZhGAh4Fd1JDrzCDZGzKrNBRhJujwvwZ-FDlEGqOt4tKLw_2mlg-xqLu7CwDaTH0Gc6XR9SM05PLlzruYqLmnirkFBE80PRGVqqtoyfWBY11w2Ek_OZN7b0nlLvpmHY8hcqmaIg-pu7lzVSzoeZvJ9Z0bm5GQfkjCv899LMl2ngDphqB1EqU1YZQCj43lKbBHlECnIhOIiXzAn8SOcquAi-yqM1hKb4V1W5Cgw`

        const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAobuAkLPw3dC4aAg4ba6B
3LCOgLl0Qb/ZPWP6f/W7Ig/YkJEMzMtENLncCicyN8/78pbqWCHfDEc4/4aJ1Wgz
r4lyd8dUYyw5fVnGxoaKEdz8R+gxyRhww75D2NGE2wQ2/ZoTlRtSSTR4XKrPqI19
CZVX5abJKNglGqOlof8A1Rd/4JnFHj2EN9nfZk9N46qIz0biIxo8oc3vZvR9wz2C
DirV0ss8q38np0YxUtluLfAK/HpPXGz2efVcrBy+KYznJiClQcVwjqJrk9uqH+JC
oIfXrjueZRRzCR0Xah7WOKXST4EYUCSvnywv6yBA9QGKmMiUpYoVR4cZQmSt3Lzl
4QIDAQAB
-----END PUBLIC KEY-----`

        const WSP = new WacomSignaturePad(key, publicKey, this.$refs['wacom-signature-pad'], who, why, extraData)

        WSP.render()

        WSP.addEventListener('file', (event) => {
          this.blob = event.file
        })

        WSP.addEventListener('cancel', (event) => {
          this.onCancel()
        })
      })

      return new Promise((resolve, reject) => {
        this.$on('confirm', (event) => {
          resolve(event)
        })
        this.$on('cancel', () => {
          reject(new Error('cancel'))
        })
      })
    }
  },

  watch: {
    blob (val) {
      if (val) {
        this.$emit('confirm', val)
        this.isVisible = false
      }
    }
  }
})
</script>
